import { useDevice } from 'device'
import cx from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'

import { Href } from 'components/navigation'
import { Icon, Text } from 'components/dataDisplay'
import { StickyContainer, WidthContainer, WidthContainerCompensator } from 'components/layout'

import s from './StickyAnnouncement.scss'


type StickyAnnouncement = {
  title: string
  text: string
  to?: string
  toTab?: string
  comment?: string
  urlText: string
}

export type StickyAnnouncementProps = {
  announcement: StickyAnnouncement
  hash?: string
  withCloseButton?: boolean
}

const checkIsClosed = (hash) => {
  if (!__SERVER__) {
    const announcementsClosedStorageItem = localStorage.getItem('announcementsClosed')

    if (!announcementsClosedStorageItem) {
      return
    }
    else {
      const announcementsClosed = announcementsClosedStorageItem.split(',')

      if (announcementsClosed.includes(hash)) {
        return true
      }
    }
  }

  return false
}

const StickyAnnouncement = (props) => {
  const { announcement, hash, withCloseButton } = props
  const { title, text, to, toTab, urlText } = announcement || {}
  const { isDesktop } = useDevice()
  const [ isClosed, setIsClosed ] = useState(() => withCloseButton && checkIsClosed(hash))

  useEffect(() => {
    if (hash && !isClosed) {
      const isClosed = checkIsClosed(hash)

      if (isClosed) {
        setIsClosed(true)
      }
    }
  }, [ hash, isClosed ])

  const handleCloseClick = useCallback(() => {
    setIsClosed(true)
    const announcementsClosedStorageItem = localStorage.getItem('announcementsClosed')

    if (!announcementsClosedStorageItem) {
      localStorage.setItem('announcementsClosed', hash)
    }
    else {
      announcementsClosedStorageItem.concat(`,${hash}`)
    }
  }, [ hash ])

  if (__SERVER__ || isClosed) {
    return (
      <div />
    )
  }

  return (
    <StickyContainer>
      <div className="flex justify-center">
        <div className={cx(s.root, 'bg-rush')}>
          <WidthContainer className="flex items-center justify-between">
            <div className="flex-1 my-16px">
              <Text
                message={title}
                size="h20-24"
              />
              <Text
                className="mt-8px"
                message={text}
                size="s13-r"
              />
            </div>
            <div className="flex justify-between">
              <Href to={to} toTab={toTab}>
                <Text
                  message={urlText}
                  size="c16"
                  color="rocky"
                />
              </Href>
              {
                withCloseButton && (
                  <Href
                    className="pointer ml-56px"
                    onClick={() => handleCloseClick()}
                  >
                    <Icon
                      name="action/close_16"
                      color="titanic"
                    />
                  </Href>
                )
              }
            </div>
          </WidthContainer>
        </div>
      </div>
    </StickyContainer>
  )
}

export default StickyAnnouncement
